import React from "react";
import { FieldProps } from "@rjsf/utils";
import { get } from "lodash";
import { MultiselectBubble } from "../../Inputs/MultiselectBubble";
import { Input } from "../__styles__/Inputs";

export const TagsInput = (props: FieldProps) => {
  const items = get(props.schema, "items.enum") as Array<string>;
  const value = props.formData ?? undefined;

  return (
    <Input id={props.idSchema.$id}>
      <MultiselectBubble
        items={items}
        selectedItems={value}
        onChange={props.onChange}
        name={props.name}
        required={props.required && !props.disabled}
        label={props.schema.title}
        error={props.rawErrors?.join(", ")}
        description={props.uiSchema?.["ui:description"]}
        disabled={false}
        readonly={props.readonly || props.disabled}
        tooltip={props.uiSchema?.["ui:tooltipText"]}
      />
    </Input>
  );
};
